import { KitSpecDetail } from "./kit-spec-detail";
import { Product } from "./product";
import { SystemField } from "./system-field";

export class KitSpec extends SystemField { 
     code?:string;
     is_active?:number;
     desc?:string;
     note?:string;
     products_id?:string;
     revision?:string;
     allow_component_addition?:number;
     component_qty?:number;
     qty?:number;
     uom_id?:string;

     // relationship
     product?:Product;
     kit_spec_details?:KitSpecDetail[];
}
